export enum TaskType {
  SYSTEM = <any>'SYSTEM',
  CUSTOM = <any>'CUSTOM'
}
